var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"svg-spritesheet"},domProps:{"innerHTML":_vm._s(_vm.spritesheetData)}})}
var staticRenderFns = []

export { render, staticRenderFns }